import mixpanel from 'mixpanel-browser';
import { BuriedPointEnum } from '/@/enums/buriedPointEnum';
import { useUserStore } from '/@/store/modules/user';
import { GetUserInfoModel } from '/@/api/sys/model/userModel';

export const handleInit = ({ mixpanelToken, mixpanelEnabled, userId, userInfo }) => {
  if (mixpanelEnabled) {
    mixpanelInit(mixpanelToken);
    mixpanelIdentify(userId);
    mixpanelRegister(userInfo);
    mixpanelSet(userInfo);
  }
};

function mixpanelInit(mixpanelToken) {
  mixpanel.init(mixpanelToken, { debug: false });
}
function mixpanelIdentify(id) {
  mixpanel.identify(id);
}
function mixpanelRegister(userInfo: GetUserInfoModel) {
  const commonParameters = getCommonParameters(userInfo);
  mixpanel.register(commonParameters);
}
function mixpanelSet(userInfo: GetUserInfoModel) {
  const commonParameters = getCommonParameters(userInfo);
  mixpanel.people.set(commonParameters);
}
function getCommonParameters(userInfo: GetUserInfoModel) {
  const user = userInfo?.user;
  const team = userInfo?.team;
  const roles = userInfo?.roles || [];

  const commonParameters = {
    $name: user?.id ? String(user.id) : undefined,
    $email: user?.email,
    teamName: team?.name,
    teamId: team?.id ? String(team.id) : undefined,
    teamType: team?.planType,
    role: roles?.length > 0 ? roles[0]?.name : undefined,
    unique_id: user?.id ? String(user.id) : undefined,
    referrer: document.referrer,
  };

  return commonParameters;
}

export function buriedPoint(point: BuriedPointEnum, options?, callback?) {
  const userStore = useUserStore();
  console.log('mixpanel.loaded', mixpanel.__loaded);
  if (mixpanel.__loaded) {
    mixpanel.track(point, options, callback);

    const userInfo = userStore.getUserInfo;
    if (userInfo) {
      mixpanelSet(userInfo);
    }
  }
}

export function mixpanelReset() {
  if (mixpanel.__loaded) {
    try {
      mixpanel.reset();
    } catch (error) {
      console.error(error);
    }
  }
}
